// pages/Home/styles.js
import styled from 'styled-components';

export const HomeWrapper = styled.main`
  min-height: calc(100vh - 64px);
`;